import { useCallback, useMemo, useState } from 'react'

export const useToggle = (defaultValue: boolean): [boolean, (value?: boolean) => void] => {
  const [value, setValue] = useState(defaultValue)

  const toggleValue = useCallback((value?: boolean) => {
    setValue((currentValue) => (typeof value === 'boolean' ? value : !currentValue))
  }, [])

  return useMemo(() => [value, toggleValue], [value, toggleValue])
}
